<template>
  <div class="aMap">
    <div class="map" id="map"></div>
    <!--v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)"-->
    <!-- <div class="point"> -->
    <!-- <i class="el-icon-location"></i>
        当前显示范围：
        <el-switch
          v-model="selectId"
          active-color="rgba(170, 253, 254, .5)"
          inactive-color="rgba(255, 255, 255, .5)"
          :inactive-value="1"
          :active-value="440000"
          active-text="广东省"
          inactive-text="全国">
        </el-switch> -->
    <!--<ElementSelect :val="selectId"-->
    <!--               :options="selectList"-->
    <!--               :transfer="false"-->
    <!--               @change="changeSelect" />-->
    <!-- </div> -->
    <div class="map-radio-box">
      <!-- <el-cascader v-model="value" :options="options" @change="handleChange" :show-all-levels="false"></el-cascader> -->
    </div>
    <!--<transition name="el-fade-in">-->
    <div
      class="map-loading"
      v-loading="loading"
      v-if="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    ></div>
    <!--</transition>-->
  </div>
</template>

<script>
import { getMapData } from '../../../api/getMapData';
import GisInfoBox from '../../../components/map/GisInfoBox';

export default {
  name: 'Map',
  props: {
    mapData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      selectId: 440000,
      selectList: [
        {
          value: 1,
          label: '全国',
        },
        {
          value: 440000,
          label: '广东省',
        },
      ],
      proCenter: [113.28, 23.125],
      loading: false,
      map: null,
      AMap: null,
      valData: {},
      maxNum: 0,
      minNum: 0,
      count: null,
      cityValData: {},
      cityMaxNum: 0,
      cityMinNum: 0,
      countGuangdong: null,
      mapObj: {
        disCity: [],
      },
      typeId: 1,
      // 全国企业500强
      countryQuotaData: {},
      // 广东企业500强
      cityQuotaData: {},
      options: [
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省本年新增市场主体',
          value: 2,
        },
        {
          label: '广东省本年注销市场主体',
          value: 3,
        },
        {
          label: '广东省市场主体类型',
          value: 4,
          children: [
            {
              label: '私营企业',
              value: 41,
            },
            {
              label: '非私营企业',
              value: 42,
            },
            {
              label: '外商投资企业',
              value: 43,
            },
            {
              label: '个体工商户',
              value: 44,
            },
          ],
        },
        {
          label: '广东省市场主体行业与产业',
          value: 5,
          children: [
            {
              label: '行业',
              value: 51,
              children: [
                {
                  label: '制造业',
                  value: 511,
                },
                {
                  label: '服务业',
                  value: 512,
                },
              ],
            },
            {
              label: '产业',
              value: 52,
              children: [
                {
                  label: '第一产业',
                  value: 521,
                },
                {
                  label: '第二产业',
                  value: 522,
                },
                {
                  label: '第三产业',
                  value: 523,
                },
              ],
            },
          ],
        },
        {
          label: '广东省小微企业',
          value: 6,
          children: [
            {
              label: '小型',
              value: 61,
            },
            {
              label: '微型',
              value: 62,
            },
            {
              label: '小微型',
              value: 63,
            },
          ],
        },
      ],
    };
  },
  watch: {
    mapData(n) {
      this.initMap();
    },
    selectId(n) {
      // this.getData();
      this.showProvince();
      this.$emit('mapCode', {
        code: n,
      });
    },
    typeId(n) {
      console.log(n, '-n');
      this.setCityColor();
    },
    loading(n) {
      this.$emit('loading', n);
    },
  },
  computed: {
    isGuangdong() {
      return this.selectId === 440000;
    },
  },
  methods: {
    changeSelect(e) {
      this.selectId = e;
    },
    showProvince() {
      let { map, AMap } = this;
      this.loading = true;
      let {
        disCountry,
        disProvince,
        disProGuangDong,
        disCity,
        layerProvince,
        layerCity,
        focusProvince,
        polygonCity,
        label,
      } = this.mapObj;

      // disCountry.hide();
      // disProvince.hide();
      disCountry && disCountry.setMap(null);
      disProvince && disProvince.setMap(null);
      disProGuangDong && disProGuangDong.setMap(null);
      focusProvince.setDistricts('');
      focusProvince.setMap(map);
      map.remove(disProvince);
      label?.hide();
      if (disCity) {
        disCity.map((item) => {
          item.hide();
        });
      }
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      if (this.selectId > 1) {
        layerProvince.hide();
        layerCity.show();
        this.getProvinceMap();
        let pos = [this.proCenter[0] + 0.05, this.proCenter[1] - 0.5];
        map?.setCenter(pos, false, 50);
        map?.setZoom(7.4);
      } else {
        layerCity.hide();
        layerProvince.show();
        this.getCountryMap();
        map?.setCenter([104.122082, 36.719192], false, 50);
        map.setZoom(4.5);
      }
      // map.setFitView();
      this.mapListen();

      setTimeout(() => {
        this.loading = false;
      }, 1500);
    },
    getColorByVal(name, focus, city) {
      var colors = {};
      let max = city ? this.cityMaxNum : this.maxNum,
        min = city ? this.cityMinNum : this.minNum;

      let r = 73,
        g = 243,
        b = 243;
      let colorArr = [
        {
          r: 0,
          g: 120,
          b: 255,
          a: 0.3,
        },
        {
          r: 0,
          g: 201,
          b: 255,
        },
        {
          r: 88,
          g: 236,
          b: 172,
        },
        {
          r: 252,
          g: 245,
          b: 194,
        },
      ];
      let a = null;

      if (city) {
        name = name.replace('市', '');
      }
      if (!colors[name]) {
        var val = city ? this.cityValData[name] : this.valData[name];
        if (city && this.typeId === 2) {
          let valObj = {};
          this.cityQuotaData.map((item) => {
            valObj[item.cityName] = item.total;
          });
          let arr = this.cityQuotaData.map((item) => item.total);
          arr = arr.sort(function (a, b) {
            return a - b;
          });

          max = arr[arr.length - 1];
          min = arr[0];
          val = valObj[name + '市'];
          console.log(max, min, valObj, val, name);
        }
        if (!val) {
          colors[name] = 'rgba(27, 95, 152, .5)';
          // colors[adcode] = 'rgba(73, 243, 243, .75)'
        } else {
          let pro = val / max;
          if (val === min) {
            let { r, g, b } = colorArr[0];
            a = 0.8;
            colors[name] = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
          } else if (pro <= 0.36) {
            let { r, g, b } = colorArr[1];
            a = (val / (max * 0.36)) * 0.8;
            // a = val / ( max * 0.36 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 0.71) {
            let { r, g, b } = colorArr[2];
            a = (val / (max * 0.71)) * 0.8;
            // a = val / ( max * 0.71 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 1) {
            let { r, g, b } = colorArr[3];
            a = (val / max) * 0.8;
            // a = val / ( max * 0.8 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          }
          // a = val / max * 0.75;
          // colors[name] =
          //   // val !== max ?
          //   val <= min ?
          //     'rgba(27, 95, 152, .5)' :
          //     'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
        }
      }
      // a ? a = Math.round(a.toFixed(2) * 100) / 100 : ''
      if (focus) {
        colors[name] = 'rgba(231, 223, 180, .8)';
      }
      return city ? [colors[name], a ? a : '.3'] : colors[name];
    },
    getData() {
      // 全国数据 - 暂不使用
      // getMapData('Country').then(async res => {
      //   let dataObj = {};
      //   let name = this.selectId > 1 ? '地市' : '省份';
      //   await res.map(item => {
      //     item[name] === '合计' ? this.count = Number(item['会员总数']) : '';
      //     item[name] !== '合计' ? dataObj[item[name]] = Number(item['会员总数']) : '';
      //   });
      //   this.valData = dataObj;
      //   let arr = [];
      //   for (let key in dataObj) {
      //     arr.push(dataObj[key]);
      //   }
      //   arr = arr.sort(function (a, b) {
      //     return a - b
      //   });
      //
      //   let max = arr[arr.length - 1], min = arr[0];
      //   this.maxNum = max;
      //   this.minNum = min;
      // })

      this.$api.screen.getGdMembersData().then((res) => {
        let { data } = res.data;
        let dataObj = {};
        data.map((item) => {
          dataObj[item.name] = item.membersTotal;
        });
        this.cityValData = dataObj;
        let arr = [];
        for (let key in dataObj) {
          arr.push(dataObj[key]);
        }
        arr = arr.sort(function (a, b) {
          return a - b;
        });

        let max = arr[arr.length - 1],
          min = arr[0];
        this.cityMaxNum = max;
        this.cityMinNum = min;
      });

      this.$api.screen.getMapCountryEnQuota().then((res) => {
        this.countryQuotaData = res.data.data;
      });

      this.$api.screen.getMapCityEnQuota().then((res) => {
        this.cityQuotaData = res.data.data;
      });

      // getMapData('Guangdong').then(async res => {
      //   let dataObj = {};
      //   await res.map(item => {
      //     item['地市'] === '合计' ? this.countGuangdong = Number(item['会员总数']) : '';
      //     item['地市'] !== '合计' ? dataObj[item['地市']] = Number(item['会员总数']) : '';
      //   });
      //   this.cityValData = dataObj;
      //   let arr = [];
      //   for (let key in dataObj) {
      //     arr.push(dataObj[key]);
      //   }
      //   arr = arr.sort(function (a, b) {
      //     return a - b
      //   });
      //
      //   let max = arr[arr.length - 1], min = arr[0];
      //   this.cityMaxNum = max;
      //   this.cityMinNum = min;
      // })
    },
    getCountryMap() {
      var disCountry = new AMap.DistrictLayer.Country({
        zIndex: 1,
        SOC: 'CHN',
        depth: 1,
        styles: {
          'nation-stroke': 'rgb(67, 242, 243)',
          'coastline-stroke': 'rgb(67, 242, 243)',
          'province-stroke': 'rgba(0, 0, 0, 0)',
          'stroke-width': 4,
          fill: function (props) {
            return 'rgba(27, 95, 152, .6)';
            // return "rgba(0, 0, 0, .1)"
          },
        },
      });
      let proOptions = {
        zIndex: 20,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            return '';
            // return this.getColorByVal(props.NAME_CHN)
          },
        },
      };
      let disProvince = new AMap.DistrictLayer.Province(proOptions);
      this.mapObj.disCountry = disCountry;
      this.mapObj.disProvince = disProvince;
      this.mapObj.proOptions = proOptions;
      // this.map ? this.mapObj.disCountry.setMap(this.map) : '';
      // this.map ? this.mapObj.disProvince.setMap(this.map) : '';
    },
    getProvinceMap() {
      let { disCity } = this.mapObj;
      const { centerList, eastList, wList, nList } = this.mapData;
      let cl = centerList.map((x) => x.city + '市'),
        el = eastList.map((x) => x.city + '市'),
        wl = wList.map((x) => x.city + '市'),
        nl = nList.map((x) => x.city + '市');
      console.log(111, centerList);
      let disProGuangDong = new AMap.DistrictLayer.Province({
        adcode: [440000],
        zIndex: 20,
        // depth: 0,
        depth: 1,
        styles: {
          'province-stroke': '#43f2f3',
          'stroke-width': (props) => {
            if (props.adcode_pro === 440000) {
              if (props.level === 'province') return 6;
              else return 2;
            } else return 0;
          },
          'city-stroke': '#49f3f3',
          fill: (props) => {
            if (cl.find((x) => x === props.NAME_CHN)) return 'rgba(148, 222, 255, 0.6)';
            if (el.find((x) => x === props.NAME_CHN)) return 'rgba(26, 93, 131, 0.6)';
            if (wl.find((x) => x === props.NAME_CHN)) return 'rgba(11, 134, 217, 0.6)';
            if (nl.find((x) => x === props.NAME_CHN)) return 'rgba(0, 28, 46, 0.6)';
          },
        },
      });
      this.mapObj.disProGuangDong = disProGuangDong;

      if (disCity?.length) {
        disCity.map((item) => {
          item.show();
        });
      }
    },
    getProvinceFocus() {
      let focusProvince = new AMap.DistrictLayer.Province({
        zIndex: 29,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            if (cl.find((x) => x === props.NAME_CHN)) return 'rgba(148, 222, 255, 0.9)';
            if (el.find((x) => x === props.NAME_CHN)) return 'rgba(26, 93, 131, 0.9)';
            if (wl.find((x) => x === props.NAME_CHN)) return 'rgba(11, 134, 217, 0.9)';
            if (nl.find((x) => x === props.NAME_CHN)) return 'rgba(0, 28, 46, 0.9)';
          },
        },
      });
      this.mapObj.focusProvince = focusProvince;
      focusProvince.show();
    },
    getLabelsData() {
      let { AMap } = this;
      let provinceData = [],
        cityData = [];

      var districtSearch = new AMap.DistrictSearch({
        // adcode: 440000,
        level: 'city',
        extensions: 'all',
        subdistrict: 2, //  显示下级行政区级数
      });

      var mask = [];
      districtSearch.search('广东省', (status, result) => {
        var bounds = result.districtList[0].boundaries;
        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]]);
        }
        this.mapObj.mask = mask;
      });
    },
    initMap() {
      // AMap 对象
      this.AMap = window.AMap;

      // this.getCountryMap();
      this.getProvinceMap();
      this.getProvinceFocus();
      // this.getLabelsData();
      // this.showProvince();
      let { disProGuangDong } = this.mapObj;
      var districtSearch = new AMap.DistrictSearch({
        // adcode: 440000,
        level: 'city',
        extensions: 'all',
        subdistrict: 2, //  显示下级行政区级数
      });
      var mask = [];
      let cityData = [];
      districtSearch.search('广东省', (status, result) => {
        console.log(status, result);
        var bounds = result.districtList[0].boundaries;
        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]]);
        }
        if (status == 'complete') {
          cityData = result.districtList[0].districtList;
          this.mapObj.cityData = [...cityData];
        }
        // var defaultLayer = new AMap.createDefaultLayer();
        var map = new AMap.Map('map', {
          zooms: [4, 10],
          center: [113, 23],
          // center: [106.122082, 33.719192],
          zoom: 7.4,
          isHotspot: false,
          defaultCursor: 'pointer',
          // resizeEnable: false,
          // dragEnable: false,
          // zoomEnable: false,
          // scrollWheel: false,
          // touchZoom: false,
          mask,
          layers: [
            disProGuangDong,
            new AMap.TileLayer.Satellite(),
            // disProvince,
            // defaultLayer
          ],
          viewMode: '2D',
        });
        disProGuangDong.setMap(map);

        this.map = map;
        this.setLabels(440000, true);
        this.$nextTick(() => {
          // if (document.getElementsByClassName('amap-mcode')[0])
          //   document.getElementsByClassName('amap-mcode')[0].innerHTML = '';
          this.mapListen();
        });
      });
    },
    setLabels(adcode = '', city) {
      let { map, AMap } = this;
      let { layerProvince, provinceData, layerCity, cityData, disCity, label } = this.mapObj;
      let isSelected = false;
      let labelObj = {
          position: [],
          text: {
            content: '',
            direction: 'center',
            style: {
              fillColor: '#fff',
              strokeColor: 'rgba(255, 255, 255, .1)',
            },
          },
        },
        selectStyle = {
          fillColor: '#000',
          strokeColor: 'rgba(255, 255, 255, .1)',
        };

      if (layerProvince) {
        map.remove(layerProvince);
      }
      if (layerCity) {
        map.remove(layerCity);
      }

      layerProvince = new AMap.LabelsLayer({
        collision: false, // 开启标注避让
        animation: true, // 开启标注淡入动画
      });
      this.mapObj.layerProvince = layerProvince;
      layerCity = new AMap.LabelsLayer({
        collision: false, // 开启标注避让
        animation: true, // 开启标注淡入动画
      });
      this.mapObj.layerCity = layerCity;

      // 选中文字样式
      if (!label) {
        label = new AMap.LabelMarker({
          ...labelObj,
          text: {
            direction: 'center',
            style: selectStyle,
          },
        });
        map.add(label);
        this.mapObj.label = label;
        label.hide();
      }

      for (let i = 0; i < provinceData?.length; i++) {
        isSelected = adcode && adcode == provinceData[i].adcode;
        !cityData?.length && provinceData[i].name === '广东省'
          ? (cityData = JSON.parse(JSON.stringify(provinceData[i].districtList)))
          : [];

        let data = provinceData[i];
        let boxHtml = this.$u.createElm('div');
        boxHtml.appendChild(
          this.$u.drawDialog(GisInfoBox, {
            cityName: data.name,
            type: 1,
            dataObj: this.countryQuotaData,
          }),
        );
        let infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: boxHtml,
          offset: new AMap.Pixel(0, -10),
        });
        infoWindow.off('mouseover').on('mouseover', (e) => {
          let center = [data.center.lng, data.center.lat];
          infoWindow.open(map, center);
        });

        infoWindow.off('mouseout').on('mouseout', (e) => {
          infoWindow.close();
        });

        let obj = {
          ...labelObj,
          position: [provinceData[i].center.lng, provinceData[i].center.lat],
        };
        obj.text.content = provinceData[i].name;
        if (isSelected && adcode !== 440000) {
          label.setPosition(obj.position);
          label.setText({
            content: obj.text.content,
          });
          label.show();
        }
        let labelsMarker = new AMap.LabelMarker(obj);
        labelsMarker.on('click', (e) => {
          this.provinceListen(e);
        });

        labelsMarker.off('mouseover').on('mouseover', (e) => {
          let center = [data.center.lng, data.center.lat];
          infoWindow.open(map, center);
        });
        labelsMarker.off('mouseout').on('mouseout', (e) => {
          infoWindow.close();
        });
        !isSelected ? layerProvince.add(labelsMarker) : '';
      }
      map.add(layerProvince);
      city ? layerProvince.hide() : '';
      JSON.stringify;
      for (let i = 0; i < cityData.length; i++) {
        isSelected = adcode && adcode == cityData[i].adcode;
        let citySearch = new AMap.DistrictSearch({
          // adcode: 440000,
          level: 'city',
          // level: "district",
          extensions: 'all',
          subdistrict: 0, //  显示下级行政区级数
        });

        if (!disCity?.length) {
          let data = cityData[i];
          let colorArr = this.getColorByVal(data.name, false, true);
          citySearch.search(cityData[i].adcode, (status, result) => {
            if (status === 'complete') {
              let bounds = result.districtList[0].boundaries;
              if (bounds) {
                //生成行政区划polygon
                for (var j = 0; j < bounds.length; j += 1) {
                  //构造MultiPolygon的path
                  bounds[j] = [bounds[j]];
                }
                disCity[i] = new AMap.Polygon({
                  zIndex: 30,
                  strokeWeight: 1,
                  path: bounds,
                  strokeColor: '#49f3f3',
                  fillOpacity: colorArr[1],
                  fillColor: colorArr[0],
                  // fillColor: '#49f3f3',
                });
                map.add(disCity[i]);
                disCity[i].hide();
                this.mapObj.disCity[i] = disCity[i];

                let boxHtml = this.$u.createElm('div');
                boxHtml.appendChild(
                  this.$u.drawDialog(GisInfoBox, {
                    cityName: data.name,
                    type: 2,
                  }),
                );
                let infoWindow = new AMap.InfoWindow({
                  isCustom: true, //使用自定义窗体
                  content: boxHtml,
                  offset: new AMap.Pixel(0, -10),
                });

                disCity[i].off('mouseover').on('mouseover', (e) => {
                  // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
                  infoWindow.open(map, cityData[i].center);
                });

                infoWindow.off('mouseover').on('mouseover', (e) => {
                  // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
                  infoWindow.open(map, cityData[i].center);
                });

                disCity[i].off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                infoWindow.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                disCity[i].off('click').on('click', (e) => {
                  this.$emit('mapCode', {
                    code: 440000,
                    name: data.name.split('市')[0],
                  });
                  this.cityListen(e, { infoWindow, infoWindowData: cityData[i] });
                });
              }
            }
          });
        }
        let obj = {
          ...labelObj,
          position: cityData[i].center,
        };
        obj.text.content = cityData[i].name;
        if (isSelected) {
          label.setPosition(obj.position);
          label.setText({
            content: obj.text.content,
          });
          label.show();
        }
        let labelsMarker = new AMap.LabelMarker(obj);
        labelsMarker.off('click').on('click', (e) => {
          this.$emit('mapCode', {
            code: 440000,
            name: cityData[i].name.split('市')[0],
          });
          this.cityListen(e);
        });
        !isSelected ? layerCity.add(labelsMarker) : '';
      }
      map.add(layerCity);
      !city ? layerCity.hide() : '';
    },
    setCityColor() {
      let { provinceData, cityData, disCity } = this.mapObj;
      if (disCity?.length) {
        let cityGD = provinceData.filter((item) => item.name === '广东省')[0];
        if (cityGD) {
          cityData = JSON.parse(JSON.stringify(cityGD.districtList));
        }
        disCity = disCity.map((item, i) => {
          let colorArr = this.getColorByVal(cityData[i].name, false, true);
          console.log(colorArr, 'colorArr');
          item.setOptions({
            fillOpacity: colorArr[1],
            fillColor: colorArr[0],
          });
        });
      }
    },
    mapListen() {
      let { map, AMap } = this;
      let that = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      map.off('complete').on('complete', function () {
        provinceData ? that.setLabels() : '';
      });

      map.off('click').on('click', (e) => {
        this.provinceListen(e);
      });
    },
    provinceListen(e) {
      let { map, AMap } = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      var px = e.pixel;
      var props =
        this.selectId > 1 ? disProvince.getDistrictByContainerPos(px) : disCountry.getDistrictByContainerPos(px);

      if (!props) {
        focusProvince.setDistricts('');
        focusProvince.setMap(map);
        label.hide();

        if (this.selectId === 440000) {
          if (polygonCity) {
            map.remove(polygonCity); //清除上次结果
            polygonCity = null;
          }
          this.setLabels('', true);
          // layerProvince.hide();
          // layerCity.show();
        } else {
          this.setLabels();
        }
      }

      if (props?.NAME_CHN && this.selectId === 1) {
        this.setLabels(props.adcode);
        if (props.NAME_CHN === '广东省') {
          this.selectId = 440000;
        } else {
          this.selectId = 1;
          focusProvince.setDistricts(props.adcode + '');
          focusProvince.setMap(map);
          layerProvince?.show();
          layerCity?.hide();
        }
      }

      this.$emit('mapCode', {
        code: this.selectId,
        name: this.selectId > 1 ? '' : props?.NAME_CHN,
      });
    },
    cityListen(e, infoData) {
      let { map, AMap } = this;
      let { polygonCity, layerProvince, layerCity } = this.mapObj;
      let { infoWindow, infoWindowData } = infoData;
      let geocoder = new AMap.Geocoder({
        city: '全国',
      });
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          let { adcode, city, citycode } = result.regeocode.addressComponent;
          adcode = `${adcode.slice(0, 4)}00`;

          let citySearch = new AMap.DistrictSearch({
            // adcode: 440000,
            // level: "province",
            level: 'district',
            extensions: 'all',
            subdistrict: 1, //  显示下级行政区级数
          });

          citySearch.search(adcode, (status, result) => {
            if (status == 'complete') {
              console.log(result, 'result');
              let bounds = result.districtList[0].boundaries;
              // 区县
              // let list = result.districtList[0].districtList;
              // list.map(item => {
              //   citySearch.search(item.name, (status1, result1) => {
              //     console.log(status1, result1)
              //   })
              // })
              if (bounds) {
                //生成行政区划polygon
                for (var i = 0; i < bounds.length; i += 1) {
                  //构造MultiPolygon的path
                  bounds[i] = [bounds[i]];
                }
                polygonCity = new AMap.Polygon({
                  strokeWeight: 1,
                  path: bounds,
                  fillOpacity: 1,
                  fillColor: '#49f3f3',
                  // fillColor: 'rgba(231, 223, 180, .8)',
                  strokeColor: '#49f3f3',
                });
                map.add(polygonCity);
                this.mapObj.polygonCity = polygonCity;

                // let boxHtml = this.$u.createElm("div");
                // boxHtml.appendChild(
                //   this.$u.drawDialog(GisInfoBox, {
                //     cityName: city
                //   })
                // );
                // let infoWindow = new AMap.InfoWindow({
                //   isCustom: true,  //使用自定义窗体
                //   content: boxHtml,
                //   offset: new AMap.Pixel(0, -10)
                // });

                if (!infoWindow) return;

                polygonCity.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                infoWindow.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                polygonCity.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                infoWindow.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });
              }
            }
          });
          this.setLabels(adcode, true);
        }
      });
    },
  },
  mounted() {
    this.getData();
    // setTimeout(() => {
    //   this.showProvince();
    // }, 5000);
  },
  beforeDestroy() {
    // this.map?.destory();
  },
};
</script>

<style lang="less" scoped>
.aMap {
  width: 100%;
  height: 980px;
  /*height: 100%;*/
  margin: 0;
  margin-left: 4px;
  /*transform: scale(.92);*/

  #map {
    width: 100%;
    height: 100%;
    background: transparent !important;
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 1;
  }

  /deep/ .amap-logo,
  /deep/ .amap-copyright {
    display: none !important;
  }

  .map-loading {
    /*width: calc(100% + 40px);*/
    /*height: calc(100% - 100px);*/
    width: 3200px;
    height: 1080px;
    background: url('~img/home/home-bg.jpg') no-repeat;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 2;
    /*backdrop-filter: blur(20px);*/

    /deep/.el-icon-loading {
      font-size: 30px;
      color: #fff;
    }
  }

  .point {
    font-size: 18px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #aafdfe;
    line-height: 43px;
    margin-top: 20px;
    margin-left: 70px;
    position: absolute;
    z-index: 2;
    .flex-center();

    /deep/.el-switch {
      width: 80px;
      position: relative;
      .el-switch__label * {
        line-height: 1;
        font-size: 14px;
        display: inline-block;
      }
      .el-switch__label {
        display: none;
        position: absolute;
        color: #fff;
        &.is-active {
          word-break: keep-all;
          display: block;
        }
      }
      .el-switch__label--right {
        z-index: 1;
        left: 5px;
      }
      /*关闭时文字位置设置*/
      .el-switch__label--left {
        /*color: #aafdfe;*/
        z-index: 1;
        right: 5px;
      }
      /*开关宽度*/
      .el-switch__core {
        color: #fff;
        width: 80px !important;

        &::after {
          border-radius: 50%;
          box-shadow: rgba(0, 0, 0, 0.1);
        }
      }
      .el-switch__core {
      }
      &.is-check {
        .el-switch__core {
          background: #aafdfe;
        }
      }
    }

    /deep/.element-select {
      height: 100%;

      .el-input__suffix,
      .el-input__suffix-inner {
        height: 100%;
        top: 50%;
        transform: translateY(-15%);
      }

      .el-select-dropdown {
        top: 229px !important;
      }
    }
  }

  .map-radio-box {
    position: absolute;
    top: 115px;
    z-index: 2;

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #aafdfe;
      line-height: 43px;

      span {
        display: inline-block;
        width: 22px;
        height: 16px;
        background: url('~img/home/map-draw.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
      }
    }
    /deep/ .el-cascader {
      margin-left: 33px;
      width: 220px;
      .el-input--suffix .el-input__inner {
        height: 24px;
        background: linear-gradient(
          0deg,
          rgba(0, 197, 250, 0.5) 0%,
          rgba(0, 197, 250, 0.48) 6%,
          rgba(0, 197, 250, 0.11) 100%
        );
        border-radius: 3px;
        border: none;
      }
      .el-input__icon {
        position: relative;

        &.el-icon-arrow-down::before {
          position: absolute;
          top: 53%;
          transform: translateY(-55%) rotate(180deg);
          right: 5px;
          color: #fff;
          content: '';
        }

        &.el-icon-circle-close {
          /*transform: none;*/
          top: 14px;
        }

        &.is-reverse::before {
          top: 50%;
          right: 0;
        }
      }

      input {
        background: linear-gradient(
          0deg,
          rgba(0, 197, 250, 0.5) 0%,
          rgba(0, 197, 250, 0.48) 6%,
          rgba(0, 197, 250, 0.11) 100%
        );
        outline: none;
        border: none;
        color: #fff;
        font-size: 14px;
      }
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
      box-shadow: none !important;
    }

    /deep/.el-radio-group {
      margin-left: 40px;
      display: flex;
      flex-direction: column;

      .el-radio {
        color: rgba(170, 253, 254, 0.6) !important;
        line-height: 43px;
        .flex-center();

        &.is-focus {
          color: #aafdfe;
        }
      }

      .el-radio__input.is-checked {
        .el-radio__inner {
          border-color: #aafdfe;
          background-color: transparent;

          &::after {
            background: #aafdfe;
          }
        }

        + .el-radio__label {
          color: #aafdfe;
        }
      }

      .el-radio__input {
        width: 18px;
        height: 18px;
      }

      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(170, 253, 254, 0.6);
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 50%;

        &:hover {
          border-color: #aafdfe !important;
        }

        &::after {
          background: transparent;
          width: 10px;
          height: 10px;
          transform: translate(-43%, -43%);
        }
      }
    }
  }

  .map-color-box {
    position: absolute;
    right: 0;
    // top: 650px;
    bottom: 43px;
    /*top: 800px;*/
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: normal;
    color: #c0c0c0;
    line-height: 24px;
    text-shadow: 0px 2px 2px rgba(16, 16, 16, 0.6);
    z-index: 2;

    .map-color {
      width: 17px;
      height: 150px;
      border: 1px solid #00c9ff;
      /*background: linear-gradient(0deg, rgba(27, 95, 152, .5) 0%, rgba(73, 243, 243, 0.75) 100%);*/
      /*background: linear-gradient(0deg, rgba(27, 95, 152, 0.5) 0%, rgba(73, 243, 243, 0.4) 100%);*/
      background: linear-gradient(0deg, #0078ff 0%, #00c9ff 36%, #58ecac 71%, #fcf5c2 100%);
      border-radius: 6px;
    }

    &::before {
      content: '高(会员总数)';
      line-height: 30px;
    }

    &::after {
      content: '低(会员总数)';
      line-height: 30px;
    }

    .num-box {
      height: calc(100% - 50px);
      position: absolute;
      text-align: right;
      top: 25px;
      right: 90px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #c0c0c0;
      line-height: 24px;
      text-shadow: 0 2px 2px rgba(16, 16, 16, 0.6);
    }
  }
}
</style>
